import Home from '@/views/liyanke/Home.vue'
import Consult from '@/views/liyanke/Consult.vue'
import ChatColorTheme from '@/views/colortheme/Chat.vue'
import SearchColorTheme from '@/views/colortheme/Search.vue'
import GuideSymptom from '@/views/guide/colortheme/Symptom.vue'
import GuideSymptomDetail from '@/views/guide/colortheme/Detail.vue'
import GuideDepartment from '@/views/guide/liyanke/Department.vue'
import Layout from '@/layout/index.vue'
import { TEMPLATE_LI_YAN_KE } from '@/utils/constant'


// 可换颜色模版
const liyankeRoutes = [{
  path: `/${TEMPLATE_LI_YAN_KE}`,
  component: Layout,
  children: [
    {
      path: ':orgUid',
      component: Home,
      meta: {
        template: TEMPLATE_LI_YAN_KE
      }
    },
    {
      path: 'consult/:orgUid',
      component: Consult,
      meta: {
        template: TEMPLATE_LI_YAN_KE
      }
    },
    {
      path: 'chat/:orgUid',
      component: ChatColorTheme,
      meta: {
        template: TEMPLATE_LI_YAN_KE
      }
    },
    {
      path: 'search/:orgUid',
      component: SearchColorTheme,
      meta: {
        template: TEMPLATE_LI_YAN_KE
      }
    },
    {
      path: 'symptom/:orgUid',
      component: GuideSymptom,
      meta: {
        template: TEMPLATE_LI_YAN_KE
      }
    },
    {
      path: 'detail/:orgUid',
      component: GuideSymptomDetail,
      meta: {
        template: TEMPLATE_LI_YAN_KE
      }
    },
    {
      path: 'department/:orgUid',
      component: GuideDepartment,
      meta: {
        template: TEMPLATE_LI_YAN_KE
      }
    }
  ]
}]
export default liyankeRoutes



// WEBPACK FOOTER //
// ./src/router/modules/liyanke.js